import type { ReactNode } from 'react';

export const symbol_5g: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-280H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h190v-110H150q-12.75 0-21.37-8.63Q120-467.25 120-480v-170q0-12.75 8.63-21.38Q137.25-680 150-680h220q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180v110h160q24.75 0 42.38 17.62Q400-474.75 400-450v110q0 24.75-17.62 42.37Q364.75-280 340-280Zm210 0q-24.75 0-42.37-17.63Q490-315.25 490-340v-280q0-24.75 17.63-42.38Q525.25-680 550-680h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H550v280h231v-112h-73q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h102q12.75 0 21.38 8.62Q840-494.75 840-482v142q0 24.75-17 42.37Q806-280 781-280H550Z"
		/>
	</svg>
);
